<template>
  <div id="ver-bar"
       :style="size"
       style="display: flex;align-items:center;flex-direction: column">
    <e-charts :size="size"
              style="margin-top: 20px"
              :options="options" />
  </div>
</template>

<script>
import ECharts from './ECharts'

const mycolor = ['#1089e7', '#f57474', '#56d0e3', '#f8b448', '#8b78f6']
export default {
  components: {
    ECharts,
  },
  data: function () {
    return {
      year: 2000,
      options: {
        title: {
          // text: '2021年疫情控制进度情况',
          left: 'center',
          top: '20px',
          textStyle: {
            color: '#fff',
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: {
          top: '20%',
          left: '10%',
          right: '10%',
          bottom: '5%',
          containLabel: true,
        },
        xAxis: {
          show: false,
        },
        /*[
          {
            show: true,
            data: titlename,
            inverse: true,
            axisLine: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              color: "#fff",
              fontSize: "14"
            }
          },
          {
            show: true,
            data: valdata,
            inverse: true,
            axisLabel: {
              color: "#fff",
              fontSize: "12"
            },
            axisLine: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            }
          }
        ],*/
        yAxis: {
          type: 'category',
          inverse: true,
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: '#fff',
            fontSize: '16',
          },
          axisLine: {
            show: false,
          },
          data: [
            '影响程度1',
            '影响程度2',
            '影响程度3',
            '影响程度4',
            '影响程度5',
          ],
        },
        series:
          /*   [{
            name: "条",
            type: 'bar',
            yAxisIndex: 0,
            data: data,
            barGategoryGap: 70,
            barWidth: 20,
            itemStyle: {
              normal: {
                barBorderRadius: 25,
                // params当前item
                color: function (params) {
                  var num = mycolor.length
                  // params.dataIndex当前item的下标
                  return mycolor[params.dataIndex % num]
                }
              }
            },
            label: {
              normal: {
                show: true,
                position: "inside",
                formatter: "{c}%"
              }
            }
          },
          {
            name: "框",
            type: 'bar',
            yAxisIndex: 1,
            data: [100, 100, 100, 100, 100],
            barGategoryGap: 50,
            barWidth: 25,
            itemStyle: {
              normal: {
                barBorderRadius: 30,
                // params当前item
                color: "none",
                borderColor: "#00c1de",
                borderWidth: 3
              }
            }
          }]*/
          [
            {
              name: '',
              type: 'bar',
              barWidth: 16, // 柱图宽度大小
              stack: '',
              label: {
                show: true,
                position: 'right',
                textStyle: {
                  color: '#ccc759',
                  fontSize: '14',
                },
              },
              itemStyle: {
                normal: {
                  barBorderRadius: 28,
                  // params当前item
                  color: function (params) {
                    const num = mycolor.length
                    // params.dataIndex当前item的下标
                    return mycolor[params.dataIndex % num]
                  },
                },
              },
              data: [10, 20, 30, 40, 20],
            },
          ],
      },
      size: {
        width: '100%',
        height: '400px',
      },
    }
  },
}
</script>

<style scoped>
</style>
